import React from 'react'
import { brand, trustpilot } from '../../../redux/app-selectors'
import { connect } from 'react-redux'
import { FsCore } from '../../../types/fs-core'
import { Button, Trustpilot as TrustpilotAtom, TrustpilotData } from '../../../atoms'

interface Link {
  link: string
  text: string
}

interface PrimaryBillboardProps {
  trustpilotData: TrustpilotData | undefined
  name: string
  jsonBody: {
    title: string
    button: {
      text: string
      link: string
      href: string
    }
    links: Link[]
  }
  showHeader: boolean
  brand: 'money' | 'uswitch'
}

const Billboard = ({ name, jsonBody, trustpilotData, brand }: PrimaryBillboardProps) => {
  const cols: Link[][] = [[], [], []]
  for (let i = 0; i < jsonBody.links.length; i++) {
    cols[i % 3].push(jsonBody.links[i])
  }

  const [col1, col2, col3] = cols.map((items) =>
    items.map((item, index) => (
      <a href={item.link} className='billboard__links-col' key={index}>
        {item.text}
      </a>
    )),
  )

  return (
    <div className='Card Card__modal billboard' id={name}>
      <h2 className='billboard__heading'>{jsonBody.title}</h2>
      {trustpilotData && (
        <TrustpilotAtom trustpilotData={trustpilotData} brand={brand}></TrustpilotAtom>
      )}
      <div className='billboard__links-container'>
        <div className='billboard__links-row'>{col1}</div>
        <div className='billboard__links-row'>{col2}</div>
        <div className='billboard__links-row'>{col3}</div>
      </div>
      <div className='billboard__button'>
        <Button href={jsonBody.button.href}>{jsonBody.button.text}</Button>
      </div>
    </div>
  )
}

export default connect((state: FsCore.State) => ({
  trustpilotData: trustpilot(state, brand(state)),
  brand: brand(state),
}))(Billboard)
